export const fetchNewspapers = async (limit = null) => {
    const API_URL = process.env.REACT_APP_BKND_URL;
    let url = `${API_URL}/get-newspaper.php`;
    // If limit exists, append query param
    if (limit) {
        url += `?limit=${limit}`;
    }
    const res = await fetch(url);
    const data = await res.json();
    return data.data;
};